import { render, staticRenderFns } from "./yatongdian.vue?vue&type=template&id=297ff992&"
import script from "./yatongdian.vue?vue&type=script&lang=ts&"
export * from "./yatongdian.vue?vue&type=script&lang=ts&"
import style0 from "./yatongdian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports